import React from 'react';
import { MenuIcon, UserIcon, PhoneIcon } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-[#F5F2ED]/95 backdrop-blur-sm border-b border-[#1B4332]/10" data-id="element-42">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-43">
        <div className="flex items-center gap-2" data-id="element-44">
          <div className="w-10 h-10 bg-[#1B4332] rounded-full flex items-center justify-center" data-id="element-45">
            <span className="text-[#F5F2ED] font-serif text-xl font-bold" data-id="element-46">
              G
            </span>
          </div>
          <div className="hidden md:block" data-id="element-47">
            <h1 className="text-[#1B4332] font-serif font-bold leading-none text-lg" data-id="element-48">
              Global Restorative
            </h1>
            <p className="text-[#1B4332]/70 text-[10px] uppercase tracking-widest" data-id="element-49">
              Health & Wellness LLC
            </p>
          </div>
        </div>

        <nav className="hidden lg:flex items-center gap-8" data-id="element-50">
          <a href="#services" className="text-[#1A374D] hover:text-[#1B4332] font-medium transition-colors" data-id="element-51">
            Medical Care
          </a>
          <a href="#mental-wellness" className="text-[#1A374D] hover:text-[#1B4332] font-medium transition-colors" data-id="element-52">
            Mental Wellness
          </a>
          <a href="#symbis-coaching" className="text-[#1A374D] hover:text-[#1B4332] font-medium transition-colors" data-id="element-53">
            SYMBIS Coaching
          </a>
          <a href="#about-us" className="text-[#1A374D] hover:text-[#1B4332] font-medium transition-colors" data-id="element-54">
            About Us
          </a>
          <a href="#contact-us" className="text-[#1A374D] hover:text-[#1B4332] font-medium transition-colors" data-id="element-55">
            Contact Us
          </a>
        </nav>

        <div className="flex items-center gap-4" data-id="element-56">
          <button className="hidden sm:flex items-center gap-2 px-4 py-2 text-[#1B4332] font-semibold border-2 border-[#1B4332] rounded-full hover:bg-[#1B4332] hover:text-white transition-all" data-id="element-57">
            <UserIcon size={18} data-id="element-58" />
            <span data-id="element-59">Patient Portal</span>
          </button>
          <button className="px-6 py-2 bg-[#B8860B] text-white font-semibold rounded-full hover:bg-[#966d09] transition-all shadow-md" data-id="element-60">
            Book Consultation
          </button>
          <button className="lg:hidden p-2 text-[#1B4332]" data-id="element-61">
            <MenuIcon size={24} data-id="element-62" />
          </button>
        </div>
      </div>
    </header>;
}